import { render, staticRenderFns } from "./NormalUserActivation.vue?vue&type=template&id=ad6c2d04&"
import script from "./NormalUserActivation.vue?vue&type=script&lang=js&"
export * from "./NormalUserActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports